;(function (angular) {
   'use strict'

   angular.module('azure.filters').filter('smallCents', smallCentsFilter)

   function smallCentsFilter($filter) {
      return function (value) {
         // eslint-disable-next-line eqeqeq
         if (value == null || value.includes('%')) {
            return value
         }

         // Ensure the value is of type number
         const parsedValue = parseFloat(value.replace('$', ''))

         if (parsedValue < 1) {
            return value
         }

         const price = $filter('dollars')(parsedValue)
         const decimalIndex = price.indexOf('.')
         let dollars
         let cents
         let returnValue

         if (decimalIndex > -1) {
            dollars = price.substring(0, decimalIndex)
            cents = price.substring(decimalIndex + 1)
            returnValue = dollars + '<sup>' + cents + '</sup>'
         } else {
            returnValue = price
         }

         return returnValue
      }
   }
})(angular)
